import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class GetAICustomersUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (channel: string): Promise<any> => {
        return await this._aiRepository.getAICustomers(channel);
    }
}

export const GetAICustomersUseCaseName = "GetAICustomersUseCaseName";